var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00122 7.99994C1.00122 4.42005 3.89525 1.50122 7.49994 1.50122C11.0786 1.50122 13.9987 4.42132 13.9987 7.99994C13.9987 11.6046 11.0798 14.4987 7.49994 14.4987C3.89398 14.4987 1.00122 11.6059 1.00122 7.99994ZM7.49994 0.501221C3.34043 0.501221 0.0012207 3.87031 0.0012207 7.99994C0.0012207 12.1582 3.3417 15.4987 7.49994 15.4987C11.6296 15.4987 14.9987 12.1595 14.9987 7.99994C14.9987 3.86904 11.6309 0.501221 7.49994 0.501221ZM8.29061 9.91788H8.72803C9.08344 9.91788 9.38416 10.2186 9.38416 10.574C9.38416 10.9567 9.08344 11.2301 8.72803 11.2301L6.54093 11.2301C6.15819 11.2301 5.8848 10.9567 5.8848 10.574C5.8848 10.2186 6.15819 9.91788 6.54093 9.91788H6.97835V8.1682H6.75964C6.3769 8.1682 6.10351 7.89481 6.10351 7.51207C6.10351 7.15666 6.3769 6.85594 6.75964 6.85594H7.63448C7.98988 6.85594 8.29061 7.15666 8.29061 7.51207L8.29061 9.91788ZM8.50932 5.10625C8.50932 5.59835 8.09924 5.98109 7.63448 5.98109C7.14238 5.98109 6.75964 5.59835 6.75964 5.10625C6.75964 4.64149 7.14238 4.23141 7.63448 4.23141C8.09924 4.23141 8.50932 4.64149 8.50932 5.10625Z",
    fill: "#636366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrey);
export default __webpack_public_path__ + "static/media/info-grey.1910a6231e8a05b0f813d2a0f0b56136.svg";
export { ForwardRef as ReactComponent };